import store from "@/store";

function onDownloadProgress(e) {
  const progress = 100 * e.loaded / e.total
  store.commit("set_progress", {progress, show:true})
}

function onDownloadComplete(e) {
  store.commit("set_progress", {progress:0, show:false})
}

export {
  onDownloadProgress,
  onDownloadComplete,
}
